import { prefetchBanners, useOrderedBanners } from './orderedBanners';
import type { Banner } from './types';

export function useBanner(prefetchedData?: Parameters<typeof useOrderedBanners>[0]): Banner | undefined {
	const banners = useOrderedBanners(prefetchedData);
	return banners[0];
}

export const prefetchBanner = prefetchBanners;
